import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import PhoneIcon from '@mui/icons-material/Phone';
import ScheduleIcon from '@mui/icons-material/Schedule';

export enum CallStatus {
  HAD_CONVERSATION = 'Had conversation',
  NOT_REACHED = 'Not reached',
  DIALING = 'Dialing',
  CURRENTLY_TALKING = 'Currently talking',
  CALL_SCHEDULED = 'Call scheduled',
}

export enum StatusType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  NEUTRAL = 'neutral',
}

export enum FilterOption {
  ALL = 'All',
  HAD_CONVERSATION = 'Had Conversation',
  NOT_REACHED = 'Not reached',
  ACTIVE = 'Active (Trying to reach)',
}

export const statusConfig = {
  [CallStatus.HAD_CONVERSATION]: {
    label: CallStatus.HAD_CONVERSATION,
    color: 'bg-[#EFFEF0] text-[#0AA619]',
    statusType: StatusType.SUCCESS,
    icon: <CheckCircleIcon fontSize="medium" />,
  },
  [CallStatus.NOT_REACHED]: {
    label: CallStatus.NOT_REACHED,
    color: 'bg-[#FEF5EE] text-[#D5441C]',
    statusType: StatusType.ERROR,
    icon: <CancelIcon fontSize="medium" />,
  },
  [CallStatus.DIALING]: {
    label: CallStatus.DIALING,
    color: 'bg-[#F3FBFF] text-[#0261B6]',
    statusType: StatusType.INFO,
    icon: <PhoneIcon fontSize="medium" />,
  },
  [CallStatus.CURRENTLY_TALKING]: {
    label: CallStatus.CURRENTLY_TALKING,
    color: 'bg-[#F3FBFF] text-[#0261B6]',
    statusType: StatusType.INFO,
    icon: <PhoneInTalkIcon fontSize="medium" />,
  },
  [CallStatus.CALL_SCHEDULED]: {
    label: CallStatus.CALL_SCHEDULED,
    color: 'bg-[#F5F7F9] text-[#667085]',
    statusType: StatusType.NEUTRAL,
    icon: <ScheduleIcon fontSize="medium" />,
  },
};

export const FILTER_OPTIONS = [
  FilterOption.ALL,
  FilterOption.HAD_CONVERSATION,
  FilterOption.NOT_REACHED,
  FilterOption.ACTIVE,
];
